import Nette from 'nette-forms'
import naja from 'naja'
import {addMultipleListeners} from 'CmsCore/js/helpers'

if(document.querySelector('body').setActive != undefined) {
	document.querySelector('body').setActive();
}

if (typeof grecaptcha === "undefined") {
	let interval = null;
	let startTime = new Date();
	interval = setInterval(function () {
		let endTime = new Date();
		let timeElapsed = endTime - startTime;

		if (timeElapsed > 10000) { // když se nenačte do 10ti sekund, reload stránku
			clearInterval(interval);
			location.reload();
			return;
		}

		if (typeof grecaptcha !== "undefined") {
			recaptchaProcess();
			clearInterval(interval);
		}
	}, 100);
} else {
	recaptchaProcess();
}

function recaptchaProcess() {
	(function(document, Nette, grecaptcha) {
		Nette.recaptcha = (grecaptcha) => {
			const items = document.querySelectorAll('.g-recaptcha');

			if (items.length > 0) {
				grecaptcha.ready(function () {
					items.forEach((item) => {
						let isRecaptchaExecuted = false;
						const form = item.closest('form');
						if (!form.hasAttribute('captcha-loaded')) {
							grecaptcha.render(item, {
								'callback': (e) => {
									isRecaptchaExecuted = true;
									Nette.validateForm(form);
								},
								'expired-callback': () => {
									isRecaptchaExecuted = false;
									Nette.validateForm(form);
								}
							});

							if (item.getAttribute('data-size') === 'invisible') {
								addMultipleListeners(form, ['click', 'touch'], (e) => {
									grecaptcha.execute();
								});
							}

							form.setAttribute('captcha-loaded', true);

							form.addEventListener('submit', (e) => {
								if (isRecaptchaExecuted === false && item.hasAttribute('data-recaptcha-message')) {
									e.preventDefault();

									Nette.addError(item, item.getAttribute('data-recaptcha-message'));
									Nette.showFormErrors(form, Nette.formErrors, focus);
								}
							});
						}
					});
				});
			}
		};

		Nette.recaptcha(grecaptcha);

		naja.addEventListener('complete', (e) => {
			Nette.recaptcha(grecaptcha);
		});

	})(document, Nette, grecaptcha);
}